import { createContext, createElement, useCallback, useContext, useMemo, useState } from 'react';
import { useOrg } from '../components/OrgContext';

// What the agent Cases screens remember while you move around Cases (LEO-FEEDBACK E23-E25, E46): the companies filter, the sort
// and the custom dates. All of it is held IN MEMORY only:
//   - it survives moving between the hub and the four lists (the provider sits above all pages), and a reload forgets it;
//   - it is never written to any browser storage and never put in a URL: it travels to the server in the body of the request;
//   - it belongs to ONE company: when the active company changes it is dropped, so a selection made in company A can never be
//     sent for company B.
// The tab of a list is NOT remembered: a list always opens on "All".
// supplierIds: null = all companies, otherwise a non-empty list of supplier ids. sort: 'value' (default) or 'recent'.
// from / to: 'YYYY-MM-DD' or null (empty by default: nothing is hidden by a date).
const FRESH = { ids: null, sort: 'value', from: null, to: null };
const Ctx = createContext({ supplierIds: null, setSupplierIds: () => {}, sort: 'value', setSort: () => {}, from: null, to: null, setDates: () => {} });

export function CasesFilterProvider({ children }) {
  const { orgId } = useOrg();
  const [state, setState] = useState({ orgId, ...FRESH });
  const mine = state.orgId === orgId ? state : { orgId, ...FRESH };
  const setSupplierIds = useCallback((next) => {
    setState((s) => ({ ...(s.orgId === orgId ? s : { orgId, ...FRESH }), orgId, ids: Array.isArray(next) && next.length ? [...new Set(next)] : null }));
  }, [orgId]);
  const setSort = useCallback((sort) => {
    setState((s) => ({ ...(s.orgId === orgId ? s : { orgId, ...FRESH }), orgId, sort: sort === 'recent' ? 'recent' : 'value' }));
  }, [orgId]);
  const setDates = useCallback((from, to) => {
    setState((s) => ({ ...(s.orgId === orgId ? s : { orgId, ...FRESH }), orgId, from: from || null, to: to || null }));
  }, [orgId]);
  const value = useMemo(() => ({ supplierIds: mine.ids, setSupplierIds, sort: mine.sort, setSort, from: mine.from, to: mine.to, setDates }),
    [mine.ids, mine.sort, mine.from, mine.to, setSupplierIds, setSort, setDates]);
  return createElement(Ctx.Provider, { value }, children);
}

export const useCasesFilter = () => useContext(Ctx);
